module.exports = __webpack_public_path__ + "img/header-phoneicon.61d367a.png";